import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "previewContainer", "previewGrid", "dropzone"]
  
  connect() {
    this.selectedFiles = []
    this.existingImages = []
    
    this.previewGridTarget.querySelectorAll('.group').forEach((item, index) => {
      const img = item.querySelector('img')
      const hiddenInput = item.querySelector('input[type="hidden"]')
      
      if (img && hiddenInput) {
        this.existingImages.push({
          element: item,
          signedId: hiddenInput.value,
          index: index
        })
      }
    })
  }
  
  browse(event) {
    const input = this.inputTarget
    if (input) {
      input.click()
    }
  }
  
  preview(event) {
    const input = event.currentTarget
    
    if (input.files && input.files.length > 0) {
      this.previewContainerTarget.classList.remove('hidden')
      
      const newFiles = Array.from(input.files)
      this.selectedFiles = [...this.selectedFiles, ...newFiles]
      
      this.updateInputFiles()
      
      const startIndex = this.existingImages.length + (this.selectedFiles.length - newFiles.length)
      newFiles.forEach((file, index) => {
        this.createPreviewItem(file, startIndex + index)
      })
    }
  }
  
  updateInputFiles() {
    const dataTransfer = new DataTransfer()
    
    this.selectedFiles.forEach(file => {
      dataTransfer.items.add(file)
    })
    
    this.inputTarget.files = dataTransfer.files
  }
  
  createPreviewItem(file, index) {
    if (!file.type.match(/^image\//)) return
    
    const reader = new FileReader()
    
    reader.onload = (e) => {
      const previewDiv = document.createElement('div')
      previewDiv.className = 'relative group'
      previewDiv.innerHTML = `
        <img src="${e.target.result}" alt="Preview ${index + 1}" class="w-full h-32 object-cover rounded-lg shadow-sm">
        <div class="absolute inset-0 group-hover:bg-black/30 transition-all rounded-lg flex items-center justify-center">
          <button type="button" 
                  class="hidden group-hover:block bg-red-500 text-white p-2 rounded-full hover:bg-red-600 transition-colors"
                  data-action="click->multiple-image-preview#removePreview"
                  data-index="${index}">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
            </svg>
          </button>
        </div>
      `
      this.previewGridTarget.appendChild(previewDiv)
    }
    
    reader.readAsDataURL(file)
  }
  
  removePreview(event) {
    event.preventDefault()
    event.stopPropagation()
    const previewItem = event.currentTarget.closest('.group')
    
    if (previewItem) {
      const isExistingImage = previewItem.querySelector('input[type="hidden"]')
      
      if (isExistingImage) {
        isExistingImage.remove()
        
        this.existingImages = this.existingImages.filter(img => img.element !== previewItem)
      } else {
        const index = parseInt(event.currentTarget.dataset.index)
        const newImageIndex = index - this.existingImages.length
        if (newImageIndex >= 0) {
          this.selectedFiles.splice(newImageIndex, 1)
          this.updateInputFiles()
        }
      }
      
      previewItem.remove()
      
      this.reindexPreviews()
    }
    
    if (this.previewGridTarget.children.length === 0) {
      this.previewContainerTarget.classList.add('hidden')
    }
  }
  
  reindexPreviews() {
    const previewItems = this.previewGridTarget.querySelectorAll('.group button[data-index]')
    previewItems.forEach((button, index) => {
      button.dataset.index = index
    })
  }
  
  removeImage(event) {
    event.preventDefault()
    const imageId = event.currentTarget.dataset.imageId
    const previewItem = event.currentTarget.closest('.group')
    
    if (previewItem && confirm('Tem certeza que deseja remover esta imagem?')) {
      const hiddenInput = document.createElement('input')
      hiddenInput.type = 'hidden'
      hiddenInput.name = 'gallery[images_to_remove][]'
      hiddenInput.value = imageId
      this.element.appendChild(hiddenInput)
      
      previewItem.remove()
    }
  }
  
  dragOver(event) {
    event.preventDefault()
    event.currentTarget.classList.remove('border-gray-300')
    event.currentTarget.classList.add('border-green-400', 'bg-green-50')
  }
  
  dragLeave(event) {
    event.preventDefault()
    event.currentTarget.classList.remove('border-green-400', 'bg-green-50')
    event.currentTarget.classList.add('border-gray-300')
  }
  
  drop(event) {
    event.preventDefault()
    const dropzone = event.currentTarget
    dropzone.classList.remove('border-green-400', 'bg-green-50')
    dropzone.classList.add('border-gray-300')
    
    if (event.dataTransfer.files.length) {
      const newFiles = Array.from(event.dataTransfer.files)
      this.selectedFiles = [...this.selectedFiles, ...newFiles]
      
      this.updateInputFiles()
      
      this.previewContainerTarget.classList.remove('hidden')
      
      const startIndex = this.existingImages.length + (this.selectedFiles.length - newFiles.length)
      newFiles.forEach((file, index) => {
        this.createPreviewItem(file, startIndex + index)
      })
    }
  }
}